import request from '@/utils/request'

/**
 *  校验订单，并获取充值金额
 * @param {*} data
 */
export function isAccountRecharge(data) {
  return request({
    url: '/index/account/isAccountRecharge',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/pay.js